<div class="loader-container" *ngIf="!bookingInit || !copyLoaded">
  <div class="loader">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" />
    </svg>
  </div>
</div>
<app-timeslots
  *ngIf="bookingInit && copyLoaded"
  [originalAirlineCode]="originalAirlineCode"
  [flightNumber]="flightNumber"
  [flightDateTime]="flightDateTime"
  [flightDirection]="flightDirection"
  [zoneInfo]="zoneInfo"
  [ccdAvailable]="ccdAvailable"
  [departureAirportCode]="departureAirportCode"
  [terminal]="terminal"
  [location]="location"
  [collectionDateTime]="collectionDateTime"
  [bookingProduct]="bookingProduct"
  [appCopy]="appCopy"
  [hasReserveError]="hasReserveError"
  [hasReserveExpiredError]="hasReserveExpiredError"
  [showLoader]="showLoader"
  [operatingCarrier]="operatingCarrier"
  (checkReserveTimeslotData)="checkReserveTimeslotData($event)"
  (sendBagNote)="sendBagNote($event)"
  (sendVirtualBags)="sendVirtualBags($event)"
  (sendBagItems)="sendBagItems($event)"
  (sendHasOversizedBag)="sendHasOversizedBag($event)"
  (goPanelBack)="goPanelBack($event)"
  (goPanelForward)="goPanelForward($event)">
</app-timeslots>